var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSideBySideWhiteP(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 234 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.53,10.997c-0,-2.287 -1.592,-3.514 -4.147,-3.514l-3.947,0l-0,7.098l4.047,-0c2.554,-0 4.047,-1.526 4.047,-3.517l-0,-0.067Zm-4.214,8.127l-3.88,-0l-0,6.965l-5.107,0l-0,-23.217l9.486,0c5.539,0 8.888,3.284 8.888,8.026l0,0.066c0,5.374 -4.179,8.16 -9.387,8.16Z",
    style: {
      fill: "#eb068c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.53,10.997c-0,-2.287 -1.592,-3.514 -4.147,-3.514l-3.947,0l-0,7.098l4.047,-0c2.554,-0 4.047,-1.526 4.047,-3.517l-0,-0.067Zm-4.214,8.127l-3.88,-0l-0,6.965l-5.107,0l-0,-23.217l9.486,0c5.539,0 8.888,3.284 8.888,8.026l0,0.066c0,5.374 -4.179,8.16 -9.387,8.16Z",
    style: {
      fill: "#eb068c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.801,14.481c0,-3.98 -2.918,-7.298 -7.031,-7.298c-4.113,0 -6.965,3.251 -6.965,7.231l0,0.067c0,3.98 2.919,7.297 7.03,7.297c4.114,-0 6.966,-3.252 6.966,-7.23l0,-0.067Zm-7.031,12.006c-7.165,-0 -12.306,-5.34 -12.306,-11.939l0,-0.067c0,-6.601 5.207,-12.007 12.371,-12.007c7.165,-0 12.307,5.338 12.307,11.94l0,0.067c0,6.599 -5.208,12.006 -12.372,12.006Z",
    style: {
      fill: "#eb068c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.801,14.481c0,-3.98 -2.918,-7.298 -7.031,-7.298c-4.113,0 -6.965,3.251 -6.965,7.231l0,0.067c0,3.98 2.919,7.297 7.03,7.297c4.114,-0 6.966,-3.252 6.966,-7.23l0,-0.067Zm-7.031,12.006c-7.165,-0 -12.306,-5.34 -12.306,-11.939l0,-0.067c0,-6.601 5.207,-12.007 12.371,-12.007c7.165,-0 12.307,5.338 12.307,11.94l0,0.067c0,6.599 -5.208,12.006 -12.372,12.006Z",
    style: {
      fill: "#eb068c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.695,26.089l0,-23.217l5.107,0l0,18.575l11.577,0l-0,4.642l-16.684,0Z",
    style: {
      fill: "#eb068c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.695,26.089l0,-23.217l5.107,0l0,18.575l11.577,0l-0,4.642l-16.684,0Z",
    style: {
      fill: "#eb068c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.232,26.089l0,-23.217l17.513,0l0,4.544l-12.438,-0l0,4.709l10.945,0l0,4.546l-10.945,0l0,4.876l12.604,-0l0,4.542l-17.679,0Z",
    style: {
      fill: "#eb068c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.232,26.089l0,-23.217l17.513,0l0,4.544l-12.438,-0l0,4.709l10.945,0l0,4.546l-10.945,0l0,4.876l12.604,-0l0,4.542l-17.679,0Z",
    style: {
      fill: "#eb068c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.709,19.986c-0,-4.51 -1.792,-8.836 -4.981,-12.025c-3.19,-3.189 -7.515,-4.981 -12.025,-4.981c-7.995,0 -17.547,0 -25.729,0c-4.922,0 -9.643,1.956 -13.123,5.436c-3.481,3.481 -5.436,8.201 -5.436,13.123l-0,20.917c-0,9.377 7.601,16.979 16.978,16.979l26.139,0c4.82,0 9.444,-1.915 12.853,-5.324c3.408,-3.409 5.324,-8.032 5.324,-12.853l-0,-21.272Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.228,27.616l11.604,0l0,-24.654l-11.085,0c-8.992,0 -16.349,6.631 -16.349,14.735l0,25.633c0.279,-3.926 1.319,-7.386 3.958,-10.559c2.708,-3.341 6.665,-5.06 11.872,-5.155Z",
    style: {
      fill: "#3f4fa2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.016,24.611c1.366,-1.726 2.049,-3.645 2.049,-5.754c0,-1.751 -0.277,-3.225 -0.833,-4.424c-0.58,-1.079 -1.39,-1.93 -2.432,-2.554c-1.575,-1.03 -3.406,-1.522 -5.489,-1.474l-11.025,-0l-0,16.939l11.303,0c2.848,-0.048 4.99,-0.959 6.427,-2.733Z",
    style: {
      fill: "#eb068c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.102,37.789c-1.366,1.726 -2.05,3.645 -2.05,5.754c0,1.75 0.278,3.225 0.834,4.424c0.58,1.078 1.39,1.93 2.432,2.554c1.576,1.029 3.406,1.521 5.49,1.474l11.024,-0l0,-16.94l-11.302,0c-2.849,0.049 -4.991,0.96 -6.428,2.734Z",
    style: {
      fill: "#3f4fa2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.89,34.783l-11.604,0l-0,24.654l11.085,0c8.992,0 16.349,-6.63 16.349,-14.734l0,-25.633c0,4.076 -1.319,7.385 -3.958,10.559c-2.708,3.341 -6.664,5.059 -11.872,5.154Z",
    style: {
      fill: "#eb068c",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.316,38.114l-5.87,0l0,10.216l5.738,-0c3.847,-0 6.368,-2.056 6.368,-5.142c0,-3.35 -2.488,-5.074 -6.236,-5.074Zm-0.231,12.604l-5.639,-0l0,8.193l-2.621,0l-0,-23.219l8.691,0c5.24,0 8.69,2.787 8.69,7.398c-0,5.041 -4.179,7.628 -9.121,7.628Z",
    style: {
      fill: "#3f4fa2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.316,38.114l-5.87,0l0,10.216l5.738,-0c3.847,-0 6.368,-2.056 6.368,-5.142c0,-3.35 -2.488,-5.074 -6.236,-5.074Zm-0.231,12.604l-5.639,-0l0,8.193l-2.621,0l-0,-23.219l8.691,0c5.24,0 8.69,2.787 8.69,7.398c-0,5.041 -4.179,7.628 -9.121,7.628Z",
    style: {
      fill: "#3f4fa2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.762,37.716c-5.307,-0 -9.088,4.245 -9.088,9.553c0,5.306 3.847,9.619 9.154,9.619c5.307,-0 9.089,-4.246 9.089,-9.553c-0,-5.306 -3.848,-9.619 -9.155,-9.619Zm-0,21.595c-7.065,-0 -11.808,-5.54 -11.808,-11.976c0,-6.435 4.81,-12.04 11.874,-12.04c7.065,-0 11.809,5.541 11.809,11.974c-0,6.434 -4.81,12.042 -11.875,12.042Z",
    style: {
      fill: "#3f4fa2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.762,37.716c-5.307,-0 -9.088,4.245 -9.088,9.553c0,5.306 3.847,9.619 9.154,9.619c5.307,-0 9.089,-4.246 9.089,-9.553c-0,-5.306 -3.848,-9.619 -9.155,-9.619Zm-0,21.595c-7.065,-0 -11.808,-5.54 -11.808,-11.976c0,-6.435 4.81,-12.04 11.874,-12.04c7.065,-0 11.809,5.541 11.809,11.974c-0,6.434 -4.81,12.042 -11.875,12.042Z",
    style: {
      fill: "#3f4fa2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.341,46.043c5.173,1.126 7.561,3.018 7.561,6.599c0,4.015 -3.315,6.601 -7.927,6.601c-3.681,0 -6.699,-1.227 -9.485,-3.714l1.625,-1.924c2.421,2.189 4.742,3.283 7.961,3.283c3.117,-0 5.172,-1.624 5.172,-3.981c0,-2.189 -1.16,-3.417 -6.036,-4.444c-5.339,-1.16 -7.794,-2.886 -7.794,-6.732c0,-3.715 3.217,-6.369 7.628,-6.369c3.385,0 5.806,0.963 8.16,2.852l-1.526,2.024c-2.155,-1.759 -4.311,-2.522 -6.699,-2.522c-3.019,-0 -4.942,1.659 -4.942,3.781c-0,2.223 1.194,3.45 6.302,4.546Z",
    style: {
      fill: "#3f4fa2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.341,46.043c5.173,1.126 7.561,3.018 7.561,6.599c0,4.015 -3.315,6.601 -7.927,6.601c-3.681,0 -6.699,-1.227 -9.485,-3.714l1.625,-1.924c2.421,2.189 4.742,3.283 7.961,3.283c3.117,-0 5.172,-1.624 5.172,-3.981c0,-2.189 -1.16,-3.417 -6.036,-4.444c-5.339,-1.16 -7.794,-2.886 -7.794,-6.732c0,-3.715 3.217,-6.369 7.628,-6.369c3.385,0 5.806,0.963 8.16,2.852l-1.526,2.024c-2.155,-1.759 -4.311,-2.522 -6.699,-2.522c-3.019,-0 -4.942,1.659 -4.942,3.781c-0,2.223 1.194,3.45 6.302,4.546Z",
    style: {
      fill: "#3f4fa2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.482,
    y: 35.692,
    width: 2.619,
    height: 23.219,
    style: {
      fill: "#3f4fa2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.482,
    y: 35.692,
    width: 2.619,
    height: 23.219,
    style: {
      fill: "#3f4fa2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.695,58.911l-2.654,0l0,-20.797l-7.795,0l0,-2.422l18.243,0l-0,2.422l-7.794,0l-0,20.797Z",
    style: {
      fill: "#3f4fa2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.695,58.911l-2.654,0l0,-20.797l-7.795,0l0,-2.422l18.243,0l-0,2.422l-7.794,0l-0,20.797Z",
    style: {
      fill: "#3f4fa2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.637,
    y: 35.692,
    width: 2.62,
    height: 23.219,
    style: {
      fill: "#3f4fa2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.637,
    y: 35.692,
    width: 2.62,
    height: 23.219,
    style: {
      fill: "#3f4fa2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.832,37.716c-5.306,-0 -9.087,4.245 -9.087,9.553c-0,5.306 3.846,9.619 9.154,9.619c5.306,-0 9.088,-4.246 9.088,-9.553c0,-5.306 -3.847,-9.619 -9.155,-9.619Zm0,21.595c-7.065,-0 -11.808,-5.54 -11.808,-11.976c0,-6.435 4.81,-12.04 11.875,-12.04c7.065,-0 11.808,5.541 11.808,11.974c0,6.434 -4.809,12.042 -11.875,12.042Z",
    style: {
      fill: "#3f4fa2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.832,37.716c-5.306,-0 -9.087,4.245 -9.087,9.553c-0,5.306 3.846,9.619 9.154,9.619c5.306,-0 9.088,-4.246 9.088,-9.553c0,-5.306 -3.847,-9.619 -9.155,-9.619Zm0,21.595c-7.065,-0 -11.808,-5.54 -11.808,-11.976c0,-6.435 4.81,-12.04 11.875,-12.04c7.065,-0 11.808,5.541 11.808,11.974c0,6.434 -4.809,12.042 -11.875,12.042Z",
    style: {
      fill: "#3f4fa2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.336,35.692l2.555,0l0,23.219l-2.09,0l-14.992,-19.038l0,19.038l-2.554,0l0,-23.219l2.456,0l14.625,18.609l0,-18.609Z",
    style: {
      fill: "#3f4fa2",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M227.336,35.692l2.555,0l0,23.219l-2.09,0l-14.992,-19.038l0,19.038l-2.554,0l0,-23.219l2.456,0l14.625,18.609l0,-18.609Z",
    style: {
      fill: "#3f4fa2",
      fillRule: "nonzero"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSideBySideWhiteP);
export default __webpack_public_path__ + "static/media/logo_side_by_side_white_P.a75a6b8afa90ca43f7262a1003bf8e11.svg";
export { ForwardRef as ReactComponent };